module.exports = __webpack_public_path__ + "static/insight-5-hero-3a7f6d645e8ca5e2dd843c7ff64d10f8.png";